<template>
  <div>
    <template
      v-if="+areacode === 10 && new Date() < new Date('2024-10-01 00:00')"
    >
      <img src="/image/anouncement_uu.png" width="100%" />
    </template>
    <template v-else>
      <div class="text-center outer">
        <div class="inner rotate">
          <div class="mb-3">
            <v-tabs
              grow
              v-model="tab"
              background-color="#3086d2"
              centered
              dark
              icons-and-text
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab :key="'qrcode'" href="#qrcode">
                QRcode
                <v-icon>mdi-qrcode</v-icon>
              </v-tab>
              <v-tab :key="'barcode'" href="#barcode">
                Barcode
                <v-icon>mdi-barcode</v-icon>
              </v-tab>
            </v-tabs>

            <div class="mt-8">
              <div v-show="tab == 'qrcode'">
                <vue-qr :text="query.barcode" :size="200"></vue-qr>
              </div>
              <div v-show="tab == 'barcode'">
                <svg id="barcode"></svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import JsBarcode from "jsbarcode";
import VueQr from "vue-qr";
export default {
  components: {
    VueQr,
  },
  data() {
    return {
      tab: "qrcode",
    };
  },
  mounted() {
    this.setBarcode();
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    areacode() {
      return this.query.uu_areacode;
    },
  },
  methods: {
    setBarcode() {
      JsBarcode("#barcode", this.query.barcode, {
        format: "CODE128",
        lineColor: "black",
        width: 1.3,
        height: 73,
        displayValue: true,
        fontSize: 15,
      });
    },
    closeWindow() {
      var vm = this;
      if (this.query.app == "line") {
        vm.$liff
          .sendMessages([
            {
              type: "text",
              text: "Member Info",
            },
          ])
          .then(() => {
            vm.$liff.closeWindow();
          });
      } else {
        /* eslint-disable no-undef */

        MessengerExtensions.requestCloseBrowser(
          function success() {},
          function error() {
            close();
            window.close();
            window.location.assign(
              "https://www.messenger.com/closeWindow/?image_url=https://www.zwiz.ai/web/public/img/zwiz_logo_white.png&display_text=Closing window..."
            );
          }
        );
        /* eslint-enable no-undef */
      }
    },
  },
};
</script>

<style lang="scss">
@media screen and(orientation: landscape) {
  //   html {
  //     transform: translateX(0%) translateY(0%) rotate(90deg) !important;
  //     height: 100vh !important;
  //     width: 100vw;
  //   }
  .inner {
    position: relative;
  }

  .outer {
    position: relative;
    padding-top: 0px;
  }
}
@media screen and(orientation: portrait) {
  //   html {
  //     transform: translateX(0%) translateY(0%) rotate(90deg) !important;
  //     height: 100vh !important;
  //     width: 100vw;
  //   }
  .barcode {
    width: 100vh;
    height: 120px;
  }
  #barcode {
    transform: rotate(-90deg);
  }
  .inner {
    position: absolute;
    top: 50%;
    left: 50%;
  }
  .rotate {
    transform: translateX(-50%) translateY(-50%) rotate(-90deg) !important;
    width: 100vh;
    height: 100vw;
  }
  .outer {
    position: relative;
    height: 100vh;
    width: 100vw;
  }
}
</style>
